<template>
  <div class="d_container">
    <my-menu menu-name="home"></my-menu>

    <div class="download_box box1">
      <div class="down_left">
        <img src="../assets/images/apple.png" />
        <span style="font-size:24px;font-weight:bold;color:#333333;display:block;">苹果版</span>
      </div>
      <div class="down_right">
        <ul>
          <li>
            <a href="https://itunes.apple.com/us/app/apple-store/id1171638702" target="_blank">人教版</a>
          </li>
          <li>
            <a href="https://itunes.apple.com/us/app/apple-store/id1179268416" target="_blank">译林版</a>
          </li>
          <li>
            <a href="https://itunes.apple.com/us/app/apple-store/id1179239368" target="_blank">北师大版</a>
          </li>
          <li>
            <a href="https://itunes.apple.com/us/app/apple-store/id1179267262" target="_blank">外研版</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="download_box box2">
      <div class="down_left">
        <img src="../assets/images/android.png" />
        <span style="font-size:24px;font-weight:bold;color:#333333;display:block;">安卓版</span>
      </div>
      <div class="down_right">
        <ul>
          <li>
            <a href="http://zhushou.360.cn/detail/index/soft_id/3585073" target="_blank">人教版</a>
          </li>
          <li>
            <a href="http://zhushou.360.cn/detail/index/soft_id/3589976" target="_blank">译林版</a>
          </li>
          <li>
            <a href="http://zhushou.360.cn/detail/index/soft_id/3589970" target="_blank">北师大版</a>
          </li>
          <li>
            <a href="http://zhushou.360.cn/detail/index/soft_id/3589974" target="_blank">外研版</a>
          </li>
        </ul>
      </div>
    </div>

    <img src="../assets/images/phone.png" class="phone" />
  </div>
</template>

<script>
  import MyMenu from '@/components/Menu'
  export default {
    data () {
      return {}
    },
    components: {
      MyMenu
    }
  }
</script>



// WEBPACK FOOTER //
// Download.vue?2fc2dd73